import { useState, useEffect } from "react";
import { Box, Form, Image } from "../../components/elements";
import data from "../../data/master/login.json";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { setUserData } from "../../actions";
import { useDispatch } from "react-redux";
const Login = () => {
  const dispatch = useDispatch();
  const { userData, token, refreshToken } = useSelector((state) => state.counter);

  const navigate = useNavigate();

  async function checkStripeAuth() {
    const urlString = window.location.search;
    const urlParams = new URLSearchParams(urlString);
    const account = urlParams.get("account");

    try {
      axios.post(process.env.REACT_APP_API_URL + "app/connect/stripe/callback", { account: account, userId: userData._id }).then((response) => {
        if (response.data.status == "success") {
          toast.success(response.data.message);

          dispatch(setUserData(response.data.userData));
          navigate("/practitioner-settings");
        } else {
          toast.error(response.data.message);
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }

  useEffect(() => {
    checkStripeAuth();
  }, []);
  return (
    <Box className="mc-auth" style={{ backgroundColor: "#000070" }}>
      <Image src={data?.pattern.src} alt={data?.pattern.alt} className="mc-auth-pattern" />
      <Box className="mc-auth-group" style={{ maxWidth: "100%" }}>
        <h1 className="text-white">Please Wait...</h1>
      </Box>
    </Box>
  );
};
export default Login;
